import { z } from 'zod';

export const emergencyContactIdParam = z.object({ id: z.string().min(1) });
export type EmergencyContactIdParam = z.infer<typeof emergencyContactIdParam>;

export const listEmergencyContactsQuery = z.object({
  patientId: z.uuid(),
});
export type ListEmergencyContactsQuery = z.infer<typeof listEmergencyContactsQuery>;

export const createEmergencyContactBody = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  phoneNumber: z.string().min(1),
  priority: z.number(),
  patientId: z.uuid(),
  relationship: z.string().optional(),
});
export type CreateEmergencyContactBody = z.infer<typeof createEmergencyContactBody>;

export const updateEmergencyContactBody = z.object({
  firstName: z.string().min(1).optional(),
  lastName: z.string().min(1).optional(),
  phoneNumber: z.string().min(1).optional(),
  priority: z.number().optional(),
  relationship: z.string().optional(),
});
export type UpdateEmergencyContactBody = z.infer<typeof updateEmergencyContactBody>;
